/**
 * German wording for everything that can go wrong against the CMS.
 *
 * The API answers in English because it is an interface, not a screen. This is
 * a public website for a Swiss folk music band; nothing English and nothing
 * technical may reach a visitor.
 *
 * The old site had none of this: a failed request left the spinner turning
 * for ever and wrote to the console.
 */

/** The request never reached the server, or the browser is offline. */
export const OFFLINE_MESSAGE =
  "Der Server ist im Moment nicht erreichbar. Bitte prüfen Sie Ihre " +
  "Internetverbindung und versuchen Sie es noch einmal.";

/**
 * The backend sleeps after 30 minutes without traffic and needs a few seconds
 * to wake up, so the first visitor of a day regularly waits. Anything that
 * takes longer than the timeout gets this, not a generic failure.
 */
export const TIMEOUT_MESSAGE =
  "Der Server hat zu lange nicht geantwortet. Er startet möglicherweise " +
  "gerade – bitte versuchen Sie es gleich noch einmal.";

/** Anything the server answered that this site cannot make sense of. */
export function unexpectedStatus(status: number): string {
  return (
    "Die Daten konnten nicht geladen werden. Bitte versuchen Sie es später " +
    `noch einmal. (Fehler ${status})`
  );
}

/** Something inside this page went wrong. Not a status a server sent. */
export const UNEXPECTED_MESSAGE =
  "Beim Anzeigen ist etwas schiefgelaufen. Bitte laden Sie die Seite neu.";

/** What the visitor reads when the server rejected the contact form. */
export const CONTACT_INVALID_MESSAGE =
  "Ihre Angaben konnten nicht verarbeitet werden. Bitte prüfen Sie " +
  "E-Mail-Adresse, Betreff und Nachricht.";

/**
 * Three submissions per hour and IP address; the limit lives in
 * src/mail/mail.controller.ts of tubetaenzig-cms.
 */
export const CONTACT_RATE_LIMITED_MESSAGE =
  "Sie haben in kurzer Zeit bereits mehrere Nachrichten geschickt. Bitte " +
  "warten Sie einen Moment und versuchen Sie es dann noch einmal.";

export const CONTACT_FAILED_MESSAGE =
  "Ihre Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es " +
  "später noch einmal.";

export const CONTACT_SUCCESS_MESSAGE =
  "Vielen Dank! Wir haben Ihre Nachricht erhalten und melden uns bald bei " +
  "Ihnen.";

/**
 * What a 400 means here.
 *
 * The CMS validates the three fields with class-validator, but its exception
 * filter collapses every BadRequestException on a public endpoint to the fixed
 * body {"message": "Invalid input"} - see describeForApi in
 * src/common/app-exception.filter.ts of tubetaenzig-cms - so there is no
 * per-field detail to translate and nothing to be gained from trying.
 *
 * The form carries the server's own limits as maxlength attributes and marks
 * the fields required, so a visitor should not be able to produce a 400 at
 * all. This is what they read if one happens anyway.
 */
export function contactValidationMessages(): string[] {
  return [CONTACT_INVALID_MESSAGE];
}
